import { useMemo } from 'react';

import { FlagPurposeType, FlagHistoryStatus, Flag } from 'types';

interface UseVerifyActionOnFlagsResult {
  allRejectionFlagsHaveActionTaken: boolean;
}

const hasActionTakenOnLatestFlagHistoryEntry = (flag: Flag): boolean => {
  const latestAction = flag.actionHistory?.[flag.actionHistory.length - 1];

  return (
    !!latestAction?.flagSubject &&
    [FlagHistoryStatus.resolved, FlagHistoryStatus.issueAddressed, FlagHistoryStatus.modified].includes(
      latestAction.actionStatus,
    )
  );
};

export const useVerifyActionOnFlags = (flags: readonly Flag[]): UseVerifyActionOnFlagsResult => {
  const allRejectionFlagsHaveActionTaken = useMemo(() => {
    const rejectionFlags = flags.filter((flag) => flag.purposeType === FlagPurposeType.rejection);
    return rejectionFlags.every((flag) => {
      return hasActionTakenOnLatestFlagHistoryEntry(flag) || !flag?.flagType;
    });
  }, [flags]);

  return { allRejectionFlagsHaveActionTaken };
};
